import Api_Mec from "./Api_Mec";
import StoreHandler from "./StoreHandler";

class MEC_Funcionarios_api extends Api_Mec {
  constructor() {
    super();
  }

  async register(form) {
    let resp;

    try {
      resp = await this.post(
        `${this.url_api}/MEC_API/MEC_Funcionarios/registro`,
        form,
        {}
      )
        .then((result) => {
          return result;
        })
        .catch((err) => {
          return err;
        });
    } catch (error) {
      console.log(error);
    }

    return resp;
  }

  async update(form) {
    let response;

    try {
      response = await this.post(
        `${this.url_api}/MEC_API/MEC_Funcionarios/update`,
        form,
        {}
      )
        .then((result) => {
          return result;
        })
        .catch((err) => {
          return err;
        });
    } catch (error) {
      console.log(error);
    }

    return response;
  }

  async login(usuario, password) {
    var storeHandler = new StoreHandler();

    const params = new URLSearchParams();
    params.append("correo_usuario", usuario);
    params.append("clave", password);

    var resp = await this.post(this.url_api + "/loginToken", params, {
      enct: false,
    }).then((response) => {
      storeHandler.setItem("mec_tk_a", response.data.token);
      storeHandler.setItem(
        "usuario",
        JSON.stringify(response.data.datos_usuario)
      );

      return response.data;
    });
    return resp;
  }

  async getCerrarSession() {
    const params = new URLSearchParams();
    var resp = await this.post(
      this.url_api + "/loginToken/sessionOut",
      params,
      {}
    ).then((response) => {
      return response.data;
    });
    return resp;
  }

  async getInfoSession() {
    const params = new URLSearchParams();
    var resp = await this.post(
      this.url_api + "/loginToken/info_session",
      params,
      { enct: false }
    ).then((response) => {
      return response.data;
    });
    return resp;
  }

  async info_conn() {
    const params = new URLSearchParams();
    var resp = null;
    try {
      resp = await this.post(this.url_api + "/loginToken/info_conn", params, {
        enct: true,
      })
        .then((response) => {
          return response.data;
        })
        .catch(function (error) {
          return error;
        });
    } catch (e) {
      console.log(e);
    }

    return resp;
  }

  async getCaptcha() {
    let resp;

    try {
      resp = await this.post(`${this.url_api}/capcha/gen_capcha`, "", {})
        .then((result) => {
          return result;
        })
        .catch((err) => {
          return err;
        });
    } catch (error) {
      console.log(error);
    }

    return resp;
  }

  async getRecoverPassword(form) {
    let resp;

    try {
      resp = await this.post(`${this.url_api}/loginToken/cla_rec`, form, {})
        .then((result) => {
          return result;
        })
        .catch((err) => {
          return err;
        });
    } catch (error) {
      console.log(error);
    }

    return resp;
  }
}

export default MEC_Funcionarios_api;
